import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiStoragesList, apiStoragesView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/storages/getData', async datas => {
    const { data } = await apiStoragesList(datas)
    return data
})

export const getView = createAsyncThunk('admin/storages/getView', async id => {
    if (!id) return viewData
    const { data } = await apiStoragesView(id)
    data.phone = data.phone ?? ''
    data.logo = ''
    data.images = []
    data.image_remove = []
    return data
})

const viewData = {
    name: '',
    secondary_name: '',
    secondary_phone: '',
    primary_name: '',
    primary_phone: '',
    address: '',
    phone: '',
    logo: '',
    images: [],
    image_remove: [],
    notes: '',
}

export const storagesSlice = createSlice({
    name: 'admin/storages',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            status: '1',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setStatus: (state, { payload }) => {
            state.table.page = 1
            state.table.status = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setStatus } = storagesSlice.actions

export default storagesSlice.reducer
